<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/withdrawalreview/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      :batchShow="true"
      batchpass="/withdrawalreview/batch"
      batchName="批量同意"
      @batchLookDialog="openAddDialog(1, dialogModel.applyIdStr, 8888)"
      batchShowType="warning"
      :showDownloadPower="true"
      downloadPower="/withdrawalreview/down"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      @down="down(1)"
      totaltext="/withdrawalreview/tdmoney"
      :totalShow="true"
      totalName="通道余额"
      @totalLookDialog="totalLookDialog(2)"
    >
      <el-form-item label="代理商/商户ID">
        <el-input
          type="text"
          v-model="formModel.userId"
          placeholder="请输入代理商/商户ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          type="text"
          v-model="formModel.orderNo"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model="formModel.phone"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账户类型" prop="accountType">
        <el-select v-model="formModel.accountType">
          <el-option
            v-for="item in accountType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="转账类型" prop="withdrawType">
        <el-select v-model="formModel.withdrawType">
          <el-option
            v-for="item in withdrawType"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      @handleSelectionChange="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :selectable="checkboxT"
        disabled="true"
        width="60"
        margin-left="5px"
      >
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="accountType"
        label="账户类型"
        min-width="150"
        :formatter="formatterTableacctType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userId"
        label="代理商/商户ID"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="idCard"
        label="身份证"
        min-width="210"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="银行预留手机号"
        min-width="210"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatterTableDataStatus"
        min-width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="withdrawType"
        label="转账类型"
        :formatter="formatterTableDatawithdrawType"
        min-width="150"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="resMsg"
        label="响应信息"
        :formatter="formatterTableData"
        min-width="210"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="age"
        label="（ 年龄"
        min-width="110"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="到账户姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="cardNo"
        label="卡号"
        min-width="210"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="amount"
        label="金额（元） ）"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{
          toDoubleThousands((scope.row.amount * 100) / 10000)
        }}</template>
      </el-table-column>

      <el-table-column
        fixed="right"
        prop="age"
        label="可转账类型"
        min-width="160"
        :formatter="formatterTableDataAge"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="200">
        <template slot-scope="scope">
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <div v-if="scope.row.status == 0" style="margin: 0px 15px 0px 0px">
              <el-button type="text" @click="openAddDialog(1, scope.row, 9999)"
                >同意</el-button
              >
            </div>
            <div v-else style="margin: 0px 15px 0px 15px">已操作!</div>
            <div>
              <el-button
                v-if="scope.row.status == 0"
                type="text"
                @click="handleback(0, scope.row)"
                >退回</el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
    </common-table>
    <show-info-dialog
      :title="hejiflag == 1 ? '合计' : '通道余额'"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div v-if="hejiflag == 1">
        <p>提现金额：{{ dialogObj }}元</p>
      </div>
      <div v-if="hejiflag == 2">
        <p>通道金额：{{ tdMoney || 0 }}元</p>
      </div>
    </show-info-dialog>
    <form-dialog
      ref="formDialog"
      formDialogTitle="同意"
      :dialogService="dialogService"
      :model="dialogModel"
      :submitData="dialogData"
      @close="dialogClose"
      @success="dialogSuccess"
      labelWidth="110px"
      class="note"
    >
      <el-radio v-model="dialogModel.withdrawType" label="1">线上转账</el-radio>
      <el-radio v-model="dialogModel.withdrawType" label="2">线下转账</el-radio>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import LYFAcctTypes from "service/constant/LYFAcctTypes";

import MallService from "service/MallService";
import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "withdrawalreview",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
  },
  data() {
    return {
      dialogObj: {},
      tdMoney: "",
      hejiflag: "",
      dialogModel: {
        withdrawType: "1",
        operate: "",
        applyIdStr: [],
      },
      flag: "",
      formModel: {
        userId: "",
        orderNo: "",
        phone: "",
        status: "",
        withdrawType: "",
        accountType: "",
      },
      tableData: [],
      multipleSelection: [],
      submitService: MallService.withdrawalreviewList,
      time: TimeRange.monthRange,
      status: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "0",
          value: "待审核",
        },
        {
          id: "1",
          value: "审核中",
        },
        {
          id: "2",
          value: "通过",
        },
        {
          id: "3",
          value: "驳回",
        },
      ],
      withdrawType: [
        {
          id: "",
          value: "全部",
        },

        {
          id: "1",
          value: "线上转账",
        },
        {
          id: "2",
          value: "线下转账",
        },
      ],
      accountType: LYFAcctTypes,
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      this.params = {
        userId: this.formModel.userId,
        orderNo: this.formModel.orderNo,
        phone: this.formModel.phone,
        withdrawType: this.formModel.withdrawType,
        accountType: this.formModel.accountType,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        this.params.beginDate = this.time[0];
        this.params.endDate = this.time[1];
      }
      return this.params;
    },
    dialogData() {
      const params = {
        withdrawType: this.dialogModel.withdrawType,
        applyIdStr: this.dialogModel.applyIdStr,
        operate: this.dialogModel.operate,
      };
    },
    dialogService() {
      return MallService.withdrawalreviewCheck;
    },
    ...mapGetters(["serverType", "tatId", "userId", "orgDetail"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        tatId: "",
        status: "",
        withdrawType: "",
        accountType: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      let str = "";
      this.multipleSelection.forEach(function (item, index) {
        str += item.id + ",";
      });
      console.log(str);
      str = str.substring(0, str.length - 1);
      this.dialogModel.applyIdStr = str.split(",");
    },
    openAddDialog(flag, item, biaoji) {
      if (biaoji == 9999) {
        this.dialogModel.applyIdStr = item.id;
      } else if (biaoji == 8888) {
        this.dialogModel.applyIdStr = item;
      }
      this.dialogModel.operate = flag;
      this.$refs.formDialog.open();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
      if (res.respCode == "0000") {
        const https = res.respMsg;
        const ifUrl =
          /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/;

        const ifHttps = ifUrl.test(https);
        if (ifHttps == true) {
          window.open(https, "_blank");
        } else {
          return;
        }
      } else {
        return;
      }
    },
    checkboxT(row, index) {
      if (row.status == 0) {
        return true;
      } else {
        return false;
      }
    },
    down(val) {
      this.hejiflag = val;
      this.doLoad(
        MallService.summoney,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogObj = result;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    totalLookDialog(val) {
      this.hejiflag = val;
      this.doLoad(
        MallService.tdmoney,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tdMoney = result;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    dialogSuccess(res) {
      this.showSuccess(res.respMsg);
      this.$refs.formDialog.closeDialog();
      this.getList();
    },
    dialogClose() {
      this.dialogModel = {
        withdrawType: "1",
        operate: "",
        applyIdStr: [],
      };
      this.$refs.commonTable.clearSelection();
    },
    handleback(flag, item) {
      this.showConfirm("是否退回？")
        .then(() => {
          this.doBack(flag, item.id);
        })
        .catch(() => {});
    },
    doBack(flag, id) {
      this.doLoad(
        MallService.withdrawalreviewCheck,
        {
          applyIdStr: id,
          operate: flag,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
            this.dialogModel = {
              withdrawType: "1",
              operate: "",
              applyIdStr: [],
            };
          });
        },
        "操作失败"
      );
    },
    formatterTableDataType: function (row, column, cellValue) {
      switch (row.type) {
        case "0":
          return "机构";
          break;
        case "1":
          return "会员";
          break;
        default:
          return "--";
      }
    },
    formatterTableDataStatus: function (row, column, cellValue) {
      switch (row.status) {
        case 0:
          return "待审核";
          break;
        case 1:
          return "审核中";
          break;
        case 2:
          return "通过";
          break;
        case 3:
          return "驳回";
          break;
        default:
          return "--";
      }
    },
    formatterTableDatawithdrawType(row, column, cellValue, index) {
      let value = "--";
      this.withdrawType.forEach((item) => {
        if (item.id == cellValue) {
          value = item.value;
        }
      });
      return value;
    },
    formatterTableDataAge(row, column, cellValue, index) {
      let value = "--";
      if (cellValue >= 18 && cellValue < 70) {
        value = "线上转账";
      } else {
        value = <span style="color: red;">线下转账</span>;
      }
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/WithdrawalReview.vue